export default {"src":"/_next/static/media/cards-icon-7.988dfd6e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};